import { OidcService, AuthServiceApi } from './Authservice';
import * as config from './Appconfig';

export const oidcService = new OidcService(config.oidc);
export const authService = new AuthServiceApi();



// WEBPACK FOOTER //
// ./src/Appstartup.ts